import { Week } from './views/week/Week'
import React, { FC } from 'react'
import { Scheduler } from './components/Scheduler/Scheduler'
import { useSchedulerPropsContext } from './context/schedulerContext.ts'
import { WeekdaySlotView } from './views/weekday/WeekdaySlotView.tsx'

export interface SchedulerSlotsDisplayProps {}

export const SchedulerSlotsDisplay: FC<
  SchedulerSlotsDisplayProps
> = () => {
  const { view } = useSchedulerPropsContext()
  return (
    <Scheduler>
      {view === 'weekday' ? <WeekdaySlotView /> : <Week />}
    </Scheduler>
  )
}
